import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search } from "lucide-react";
import { fieldByKey } from "@/lib/fields";

const TATS = ["In TAT", "Due Today", "Out TAT", "Over TAT", "Beyond TAT"];

export default function CasesFilters({ search, onSearchChange, onSearchSubmit, tat, onTatChange,
  caseStatus, onCaseStatusChange, priority, onPriorityChange, feName, onFeNameChange, onFeBlur }) {
  return (
    <div className="bg-white border border-[#E5E7EB] p-3 flex flex-wrap gap-2 items-center" data-testid="cases-filters">
      <form onSubmit={(e) => { e.preventDefault(); onSearchSubmit(); }} className="flex gap-2">
        <Input value={search} onChange={(e) => onSearchChange(e.target.value)} placeholder="Search company, ref, candidate, pincode..."
          className="rounded-sm w-64" data-testid="cases-search-input" />
        <Button type="submit" variant="outline" className="rounded-sm" data-testid="cases-search-button">
          <Search className="h-4 w-4" />
        </Button>
      </form>
      <Select value={tat || "all"} onValueChange={(v) => onTatChange(v === "all" ? "" : v)}>
        <SelectTrigger className="rounded-sm w-40" data-testid="filter-tat-select"><SelectValue placeholder="TAT" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All TAT</SelectItem>
          {TATS.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={caseStatus || "all"} onValueChange={(v) => onCaseStatusChange(v === "all" ? "" : v)}>
        <SelectTrigger className="rounded-sm w-44" data-testid="filter-status-select"><SelectValue placeholder="Case Status" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Statuses</SelectItem>
          {(fieldByKey("case_status")?.options || []).map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={priority || "all"} onValueChange={(v) => onPriorityChange(v === "all" ? "" : v)}>
        <SelectTrigger className="rounded-sm w-36" data-testid="filter-priority-select"><SelectValue placeholder="Priority" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Priority</SelectItem>
          <SelectItem value="Yes">Priority</SelectItem>
          <SelectItem value="No">Normal</SelectItem>
        </SelectContent>
      </Select>
      <Input value={feName} onChange={(e) => onFeNameChange(e.target.value)} onBlur={onFeBlur}
        placeholder="FE Name" className="rounded-sm w-36" data-testid="filter-fe-input" />
    </div>
  );
}
